import { BetSlipPlacementStates } from "app/utils/const";
import type { Node } from "react";
import { Component, Suspense } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import Collapsible from "../../components/Collapsible/Collapsible";
import { IconClose } from "../../components/Icon/Icon";
import Progressive from "../../images/betplacement/progressive.png";
import Modal from "../Modal/Modal";
import "./BetPlacementModal.scss";

type Props = {
  children: Node;
  modalOpen?: boolean;
  closeModal: (...args: Array<any>) => any;
  contentLabel: string;
  cancelButton?: boolean;
  className?: string;
  displayBetplacementModal: boolean;
  updateShowBetplacementModal: (...args: Array<any>) => any;
};
type State = {
  modalActive: boolean;
  inPlay: boolean;
  liveMatchIncident: boolean;
  marketOdds: boolean;
};

class BetPlacementModal extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      modalActive: false,
      inPlay: true,
      liveMatchIncident: true,
      marketOdds: true,
    };
    this.activateModal = this.activateModal.bind(this);
    this.deactivateModal = this.deactivateModal.bind(this);
    this.getApplicationNode = this.getApplicationNode.bind(this);
  }

  activateModal = () => {
    !this.props.displayBetplacementModal &&
      this.setState({
        modalActive: true,
      });
  };
  deactivateModal = () => {
    this.setState({
      modalActive: false,
    });
    this.props.updateShowBetplacementModal(false);
  };
  getApplicationNode = () => {
    return document.getElementById("application");
  };
  shouldComponentUpdate = (
    nextProps: Record<string, any>,
    nextState: Record<string, any>
  ) => {
    if (
      nextProps.displayBetplacementModal &&
      this.props.displayBetplacementModal === false
    ) {
      if (!this.state.modalActive && !this.props.displayBetplacementModal)
        this.activateModal();
    }

    return true;
  };
  onToggleCollapsible = (type: string) => {
    if (type === BetSlipPlacementStates.IN_PLAY) {
      this.setState({
        inPlay: !this.state.inPlay,
      });
    } else if (type === BetSlipPlacementStates.LIVE_MATCH_INCIDENTS) {
      this.setState({
        liveMatchIncident: !this.state.liveMatchIncident,
      });
    } else if (type === BetSlipPlacementStates.MARKET_ODDS) {
      this.setState({
        marketOdds: !this.state.marketOdds,
      });
    }
  };

  render() {
    const modal = this.state.modalActive ? (
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <Modal
          contentLabel={"Betting on 3et"}
          closeModal={this.deactivateModal}
        >
          <div
            id="demo-one-modal"
            className="bet-placement-session-modal bet-placement__modal"
          >
            <header onClick={this.deactivateModal}>
              <span>
                <span className="info-icon">i</span>
                <span className="header-text">
                  <FormattedMessage tagName="span" id="bet-placement-text-h1" />
                </span>
              </span>
              <div
                id="session-modal-deactivate"
                className="asian-position-matrix-modal__header__close"
                onClick={() => this.deactivateModal}
              >
                <IconClose />
              </div>
            </header>
            <div className="bet-placement-session-modal__body">
              <p>
                <FormattedMessage tagName="span" id="bet-placement-text-p1" />
              </p>
              <p>
                <FormattedMessage tagName="span" id="bet-placement-text-p2" />
              </p>
              <Collapsible
                status={"open"}
                onToggle={() => this.onToggleCollapsible("IN_PLAY")}
                header={
                  <div className="collapsible-header">
                    <FormattedMessage
                      tagName="span"
                      id="bet-placement-text-h3"
                    />
                  </div>
                }
                content={
                  <div className="collapsible-content">
                    <p>
                      <FormattedMessage
                        tagName="span"
                        id="bet-placement-text-p3"
                      />
                    </p>
                    <p className="bet-placement-text-p4">
                      <FormattedMessage
                        tagName="span"
                        id="bet-placement-text-p4"
                      />
                      <span className="eg">Eg:</span>
                    </p>
                    <p className="screenshot">
                      <img
                        className="screenshot-image"
                        src={Progressive}
                        alt="screenshot"
                      />
                    </p>
                    <p>
                      <FormattedMessage
                        tagName="span"
                        id="bet-placement-text-p6"
                      />
                    </p>
                  </div>
                }
                isActive={this.state.inPlay}
                withArrows
              />
              <Collapsible
                status={"open"}
                onToggle={() => this.onToggleCollapsible("MARKET_ODDS")}
                header={
                  <div className="collapsible-header">
                    <FormattedMessage
                      tagName="span"
                      id="bet-placement-text-h2"
                    />
                  </div>
                }
                content={
                  <div className="collapsible-content">
                    <p>
                      <FormattedMessage
                        tagName="span"
                        id="bet-placement-text-p7"
                      />
                    </p>
                    <p>
                      <FormattedMessage
                        tagName="span"
                        id="bet-placement-text-p8"
                      />
                    </p>
                    <p className="bet-placement-text-p9">
                      <FormattedMessage
                        tagName="span"
                        id="bet-placement-text-p9"
                      />
                    </p>
                  </div>
                }
                isActive={this.state.marketOdds}
                withArrows
              />
            </div>
          </div>
        </Modal>
      </Suspense>
    ) : (
      ""
    );
    return (
      <div className="session-modal-dom-element" onClick={this.activateModal}>
        {modal}
      </div>
    );
  }
} // try and find cleaner way of doing this

const mapStateToProps = state => ({
  displayBetplacementModal: state.navigationModel.displayBetplacementModal,
});

const mapDispatchToProps = (dispatch: any) => ({
  updateShowBetplacementModal: (show: boolean) => {
    dispatch.navigationModel.updateShowBetplacementModal(show);
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(BetPlacementModal)) as any;
